export * from "./DailyExercisesTable";
export * from "./PatientExercisesTable";
